import * as React from "react";
const SvgFiRrMassage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-massage_svg__a)">
      <path
        fill="#062147"
        d="M7.388 13.297c-.075-.048.06.066 0 0m9.152.046c-.058.063.072-.046 0 0m7.433-1.614C23.07 17.585 17.923 22 12 22 6.077 22 .93 17.584.027 11.729a2.35 2.35 0 0 1 .664-2.037 2.35 2.35 0 0 1 2.036-.664c1.557.24 3.013.78 4.311 1.555.256-2.731 1.334-5.527 3.002-7.64a2.48 2.48 0 0 1 1.961-.944 2.48 2.48 0 0 1 1.962.944c1.665 2.11 2.742 4.906 2.998 7.639a11.9 11.9 0 0 1 4.31-1.555 2.35 2.35 0 0 1 2.037.664c.537.539.78 1.281.663 2.036zm-13.028 8.215c-.279-2.596-1.642-4.992-3.557-6.647-1.359-1.115-3.142-2.011-4.964-2.292a.5.5 0 0 0-.317.102.35.35 0 0 0-.102.318c.7 4.537 4.45 8.039 8.94 8.519M12 16.223a12.3 12.3 0 0 1 3.018-4.199c.056-2.727-.93-5.695-2.623-7.842A.5.5 0 0 0 12.003 4a.5.5 0 0 0-.392.182c-1.696 2.15-2.684 5.119-2.629 7.842a12.3 12.3 0 0 1 3.019 4.199m9.893-5.116c-.124-.132-.296-.105-.318-.102-1.825.281-3.677 1.22-5.036 2.337-1.916 1.655-3.205 4.005-3.483 6.602 4.489-.48 8.24-3.982 8.939-8.52a.37.37 0 0 0-.102-.317"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-massage_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMassage;
